import script from "./FlowDiagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlowDiagram.vue?vue&type=script&setup=true&lang=ts"

import "./FlowDiagram.vue?vue&type=style&index=0&id=0ffafa8e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffafa8e"]])

export default __exports__